import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolClientId,
      loginWith: {
        oauth: {
          domain: `${environment.cognitoDomain}.auth.${environment.region}.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [environment.redirectSignIn],
          redirectSignOut: [environment.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
}, );
